<template>
  <div>
    <SGPModalComponent
      tamanho="xg"
      titulo="Detalhes"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >    
    <DetalheTarefasComponent 
        :filtrosTarefas="filtrosTarefas"
     />
    </SGPModalComponent>
  </div>
</template>

<script>
import DetalheTarefasComponent from '../components/DetalheTarefasComponent.vue'
export default {
  name: "ModalDetalheTarefasComponent",
  props: {
    filtrosTarefas: {
      type: Object,
      required: true
    }
  },
  components: { 
    DetalheTarefasComponent
  },
  methods: {
    fecharModal () {
      setTimeout( () => {
        this.$emit('sgpModalFechar')
      }, 1000) 
    },
  },
}
</script>